export enum ProductType {
    dossier = 'DOSSIER',
    mortgage = 'MORTGAGE'
}

export const productTypes = Object.values(ProductType) as string[]
